<template>
	<DjBox>
		<BaseCloudImage
			class="max-w-full rounded-t-2xl overflow-hidden"
			:public-id="photoId"
			:alt="text || title"
			postfix=".jpg"
			:transformation="[{ width: 440, crop: 'scale' }]"
		/>
		<h3 class="m-3 md:m-6 text-lg md:text-xl font-medium">{{ title }}</h3>
		<div class="content-rte m-3 md:m-6" v-if="text" v-html="text"></div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import DjBox from "./DjBox.vue";
import BaseCloudImage from "../BaseCloudImage.vue";

export default defineComponent({
	name: "DjBoxPhotoWithRte",
	components: {
		BaseCloudImage,
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "",
			required: true,
		},
		photoId: {
			type: String,
			default: "",
			required: true,
		},
		text: {
			type: String,
			default: "",
			required: false,
		},
	},
});
</script>
